import React from 'react';
import { Select, MenuItem } from '@mui/material';

interface StatusSelectProps {
  active: boolean;
  onChange: (value: string) => void;
  placeholder: string;
  activeText: string;
  inactiveText: string;
}

export const StatusSelect = ({ active, onChange, placeholder, activeText, inactiveText }: StatusSelectProps) => {
  const value = active ? 'active' : 'inactive';

  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      style={{ width: '200px', border: 'none' }}
    >
      <MenuItem value="" disabled>
        {placeholder}
      </MenuItem>
      <MenuItem value="active">{activeText}</MenuItem>
      <MenuItem value="inactive">{inactiveText}</MenuItem>
    </Select>
  );
};
